import store from "../store";
import Constants from "../config/constants";
import {
  serviceCreateBroadcast,
  serviceGetBroadcast,
  serviceUpdateBroadcast,
} from "../services/Broadcast.service";
import EventEmitter from "../libs/Events.utils";

export const FETCH_INIT = "FETCH_INIT_BROADCAST";
export const FETCHED = "FETCHED_BROADCAST";
export const FETCHED_FAIL = "FETCHED_FAIL_BROADCAST";
export const FETCHED_FILTER = "FETCHED_FILTER_BROADCAST";
export const FETCH_NEXT = "FETCH_NEXT_BROADCAST";
export const FILTER = "FILTER_BROADCAST";
export const RESET_FILTER = "RESET_FILTER_BROADCAST";
export const SET_SORTING = "SET_SORTING_BROADCAST";
export const SET_FILTER = "SET_FILTER_BROADCAST";
export const SET_PAGE = "SET_PAGE_BROADCAST";
export const CHANGE_PAGE = "CHANGE_PAGE_BROADCAST";
export const CHANGE_STATUS = "CHANGE_STATE_BROADCAST";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_BROADCAST";
export const CREATE_DATA = "CREATE_BROADCAST";
export const UPDATE_DATA = "UPDATE_BROADCAST";
export const DELETE_ITEM = "DELETE_BROADCAST";
export const RESET_STATE = "RESET_STATE";

export function actionFetchBroadcast(index = 1, sorting = {}, filter = {}) {
  const request = serviceGetBroadcast({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
  });
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index == 1) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}

export function actionCreateBroadcast(data) {
  const request = serviceCreateBroadcast(data);
  return (dispatch) => {
    request.then((data) => {
      if (!data.error) {
        EventEmitter.dispatch(EventEmitter.THROW_ERROR, {
          error: "Saved",
          type: "success",
        });
        dispatch({ type: CREATE_DATA, payload: data.data });
      }
    });
  };
}

export function actionUpdateBroadcast(data) {
  const request = serviceUpdateBroadcast(data);
  return (dispatch) => {
    request.then((data) => {
      if (!data.error) {
        dispatch({ type: UPDATE_DATA, payload: data.data });
      }
    });
  };
}



export function actionChangePageBroadcast(page) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PAGE, payload: page });
  };
}

export function actionFilterBroadcast(value) {
  const request = null; ////serviceFetchProviderRequests(value);
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: FILTER, payload: data });
      dispatch({ type: FETCHED, payload: null }); //dispatch function
    });
  };
}

export function actionChangeStatusBroadcast(id, status) {
  return (dispatch) => {
    dispatch({ type: CHANGE_STATUS, payload: { id, status } });
  };
}

export function actionResetFilterBroadcast() {
  return {
    type: RESET_FILTER,
    payload: null,
  };
}
export function actionResetBroadcast() {
  return {
    type: RESET_STATE,
  };
}

export function actionSetPageBroadcast(page) {
  const stateData = store.getState().broadcast;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;

  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
      actionFetchBroadcast(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
      })
    );
  }

  console.log(currentPage, totalLength);
  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}
